module.exports = __webpack_public_path__ + "static/media/Tiscali.c01f8d65.svg";